import { FC } from "react";
import DefaultLayout from "@/layouts/DefaultLayout";
import usePageView from "@/hooks/usePageView";
import { useSearchParams } from "next/navigation";
import SearchResultContent from "@/pages/SearchIndexPage/components/SearchResultContent";
import Maybe from "@/components/Maybe";
import SearchResultGroup from "@/components/SearchResultGroup";
import { SearchResultTabType } from "@/consts/tabType";

const SearchIndexPage: FC = () => {
  usePageView();

  const searchParams = useSearchParams();
  const keyword = searchParams.get("keyword");

  return (
    <DefaultLayout className="!bg-white">
      <SearchResultGroup keyword={keyword} tabType={SearchResultTabType.All}>
        <div className="py-24">
          <div className="overflow-hidden">
            <Maybe condition={!!keyword}>
              <SearchResultContent keyword={keyword} />
            </Maybe>
          </div>
        </div>
      </SearchResultGroup>
    </DefaultLayout>
  );
};
export default SearchIndexPage;
